import { render } from "./CoursesImport.vue?vue&type=template&id=7028fc31"
import script from "./CoursesImport.vue?vue&type=script&lang=js"
export * from "./CoursesImport.vue?vue&type=script&lang=js"

import "./CoursesImport.vue?vue&type=style&index=0&id=7028fc31&lang=scss"
script.render = render

export default script